module.exports = __webpack_public_path__ + "static/media/c16b0c00-65d8-4afb-8607-656a29f5f6eb.5dd6fe8c.JPG";